export default "__VITE_ASSET__DBuR260g__"